
import navBar from "./en/navBar"
import error from "./en/error"
import commons from "./en/commons"
import market from "./en/market"

export default {
  translation: {
    ...navBar,
    ...error,
    ...commons,
    ...market
  }
}